import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-energy2",
  "use": "icon-energy2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-energy2\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.772 77.57L135.735 294.784v434.43l376.037 217.216 376.037-217.216v-434.43L511.772 77.569z m17.99-72.747l412.02 238A36.003 36.003 0 0 1 959.771 274v476a36.003 36.003 0 0 1-17.99 31.177l-412.02 238a35.966 35.966 0 0 1-35.98 0l-412.02-238A36.003 36.003 0 0 1 63.773 750V274a36.003 36.003 0 0 1 17.99-31.177l412.02-238a35.966 35.966 0 0 1 35.98 0zM407.826 544c-26.088 0-43.505-26.908-32.834-50.726l103.947-232c8.13-18.143 29.419-26.257 47.552-18.124 18.134 8.133 26.244 29.433 18.116 47.576L463.386 472H615.72c25.894 0 43.31 26.543 33.015 50.314l-103.947 240c-7.901 18.243-29.088 26.623-47.322 18.718-18.233-7.905-26.61-29.103-18.708-47.346L560.912 544H407.825z\" p-id=\"16880\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/energy2.svg
// module id = OEHQ
// module chunks = 197